// extracted by mini-css-extract-plugin
export default {"productGrid":"tba-z","centerLink":"uba-z","productSection":"vba-z","item":"wba-z","ctaButton":"xba-z"};